import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { getFormValues, reduxForm, SubmissionError } from 'redux-form'
import { Button, Modal, TextArea } from 'semantic-ui-react'

import { getDocumentTypes } from '../../helper'
import { ProcurementBody } from '../../../styled'
import { BottomActionsContainer } from '../styled'
import {
  approverPRAction,
  deletePr,
  updatePr
} from 'ducks/purchaseRequisition'
import { showModal, appLoading } from 'ducks/app'
import { scrollToFirstValidateFailElement } from 'core/utilities'

const cancelButton = (valueForm, actions, setShowInConfirmModal) => {
  const status = valueForm ? valueForm.status !== undefined ? valueForm.status : -1 : -1
  var btnTitle = ''

  if (status === 0) {
    btnTitle = 'Delete Document'
  }

  if (status === 5 && actions.indexOf('Cancel') !== -1) {
    btnTitle = 'Cancel Document'
  }

  return (
    btnTitle !== '' ?
      <div className='cancelBtn'>
        <Button icon='close' color='red' content={btnTitle} type='button' onClick={() => setShowInConfirmModal(true)} />
      </div> : null
  )
}

const validateCancelDocument = (actionComment, setErrorRequireComment) => {
  if (actionComment.trim() === "") {
    setErrorRequireComment(true)
    return false
  } else {
    setErrorRequireComment(false)
    return true
  }
}

const EditPRAction = (props) => {
  const {
    valueForm,
    setShowInConfirmModal,
    showInConfirmModal,
    actionComment,
    setActionComment,
    errorRequireComment,
    setErrorRequireComment,
    actions,
    prId,
    sn,
    approverPRAction,
    deletePr,
    history,
    updatePr,
    setIsResubmit,
    isResubmit,
    handleSubmit,
    attachmentTypes,
    showModal,
    appLoading
  } = props
  const [isDisableBtn, setIsDisableBtn] = React.useState(false)
  
  function submitValidate(values, submitAction) {
    setIsDisableBtn(true)
    setIsResubmit(submitAction === 're-submit')
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
      .then(() => {
        let error = {}
        if (!values.title ? true : !values.title.trim()) {
          error = { ...error, title: 'Required!' }
        }
        if (!values.requesterUser) {
          error = { ...error, requesterUser: 'Required!' }
        }
        if (!values.companyCode) {
          error = { ...error, companyCode: 'Required!' }
        }
        if (!values.documentDate) {
          error = { ...error, documentDate: 'Required!' }
        }
        if (values.isAdditional) {
          if (!values.additionalReason ? true : !values.additionalReason.trim()) {
            error = { ...error, additionalReason: 'Required!' }
          } if (!values.referencePoNo ? true : !values.referencePoNo.trim()) {
            error = { ...error, referencePoNo: 'Required!' }
          }
        } else {
          values.additionalReason = ''
          values.referencePoNo = ''
          values.referenceContractNo = ''
        }
        if (values.special) {
          if (!((values.specialReason || '').startsWith('SP') && (values.specialReason || '').length === 4)) {
            if (!values.specialTitle ? true : !values.specialTitle.trim()) {
              error = { ...error, specialTitle: 'Required!' }
            }
          }

          if (!values.specialReason ? true : !values.specialReason.trim()) {
            error = { ...error, specialReason: 'Required!' }
          }

          if ((values.specialReason || '').startsWith('SP') && (values.specialReason || '').length === 4) {
            if (values.specialReason === 'SP04') {
              if (!values.subSpecialReason ? true : !values.subSpecialReason.trim()) {
                error = { ...error, subSpecialReason: 'Required!' }
              }
            }
            
            if (!values.vendorCode ? true : !values.vendorCode.trim()) {
              error = { ...error, vendorCode: 'Required!' }
            }
          }
        } else {
          values.specialTitle = ''
          values.specialReason = ''
          values.subSpecialReason = ''
        }
        
        if (Object.keys(error).length) {
          scrollToFirstValidateFailElement(error)
          throw new SubmissionError(error)
        } else {
          if (submitAction === 'save') {
            updatePr(values, false, history, appLoading, () =>{setIsDisableBtn(false)})
          } else {
            let check = false
            if (((values.budgetData || {}).internalOrder || []).length) {
              let missingPlan = values.budgetData.internalOrder.filter(b => b.plan === 0 || b.plan === undefined)
              if (missingPlan.length !== 0) {
                showModal(true, `Can't submit`, 'Cannot submit this document. Because internal order plan is zero!')
              } else {
                check = true
              }
            } else {
              check = true
            }
            if (check) {
              let missingAttachments = validateAttachments()
              if (missingAttachments.length) {
                showModal(
                  true,
                  'Please attach document!',
                  <Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></Fragment>
                )
              } else {
                if (submitAction === 're-submit') {
                  setShowInConfirmModal(true)
                } else if (submitAction === 'submit') {
                  updatePr({ ...values, comment: actionComment }, true, history, appLoading, () =>{setIsDisableBtn(false)})
                }
              }
            }
          }
        }
      })
  }

  function checkValidateItems() {
    if (!valueForm.items.length) {
      return true
    } else {
      let itemDeleted = valueForm.items.filter(x => x.deleted === true)
      if (itemDeleted.length === valueForm.items.length) {
        return true
      }
    }
    return false
  }

  function validateAttachments() {
    const errors = []
    const attachmentType = attachmentTypes.find(a => a.code === valueForm.attachmentType)
    let documentTypes = getDocumentTypes(attachmentType, valueForm.special, valueForm.isAdditional)
    documentTypes.forEach((dt) => {
      const code = dt.code.toLowerCase()
      if (dt.isRequire) {
        let docValue = valueForm[code]
        if (docValue) {
          if (!docValue.length) {
            errors.push({ fieldName: dt.name, message: 'Required!' })
          }
        } else {
          const checkDoc = valueForm.attachments.filter(a => a.documentTypeCode.toLowerCase() === code && !a.deleted)
          if (!checkDoc.length) {
            errors.push({ fieldName: dt.name, message: 'Required!' })
          }
        }
      }
    })
    return errors
  }

  return (
    <ProcurementBody>
      <BottomActionsContainer>
        {cancelButton(valueForm, actions, setShowInConfirmModal)}
        <div>
          {[0, '0'].indexOf(valueForm.status) >= 0 &&
            <Button
              type='button'
              content='Save'
              icon='save'
              disabled={checkValidateItems() || isDisableBtn}
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={
                // setSubmitAction('save')
                handleSubmit(() => submitValidate(valueForm, 'save') )
              }
            />}
          {[5, '5'].indexOf(valueForm.status) >= 0 ?
            <Button
              type='button'
              content='Save & Re-Submit'
              color='blue'
              icon='save'
              disabled={checkValidateItems()|| isDisableBtn}
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={
                handleSubmit(() => submitValidate(valueForm, 're-submit'))
              }
            />
            :
            <Button
              type='button'
              content='Save & Submit'
              color='blue'
              icon='save'
              disabled={checkValidateItems()|| isDisableBtn}
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={
                handleSubmit(() => submitValidate(valueForm, 'submit'))
              }
            />
          }
        </div>
      </BottomActionsContainer>
      <Modal size='tiny' open={showInConfirmModal}>
        <Modal.Header>Are you sure?</Modal.Header>
        <Modal.Content>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {isResubmit ?
              null
              :
              <span>
                Are you sure to <b>{valueForm && valueForm.status === 0 ? 'delete' : 'cancel'}</b> this document?
              </span>
            }
            {
              valueForm && valueForm.status === 5 ?
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                  <div>Comment {`${isResubmit ? '' : '*'}`} {errorRequireComment ? <span style={{ color: 'red' }}>Require</span> : null} </div>
                  <TextArea
                    name='actionComment'
                    value={actionComment}
                    onChange={(e, data) => setActionComment(data.value)}
                  />
                </div> : null
            }
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color='red' onClick={() => {
            setActionComment('')
            setShowInConfirmModal(false)
            setErrorRequireComment(false)
          }}>
            No
          </Button>
          <Button
            positive
            icon='checkmark'
            labelPosition='right'
            content={'Yes'}
            onClick={() => {
              if (isResubmit) {
                setShowInConfirmModal(false)
                updatePr({ ...valueForm, comment: actionComment }, true, history, appLoading, () =>{setIsDisableBtn(false)})
              } else {
                if (valueForm && valueForm.status === 0) {
                  setShowInConfirmModal(false)
                  deletePr(prId, { sn, comment: actionComment }, history)
                } else {
                  if (validateCancelDocument(actionComment, setErrorRequireComment)) {
                    setShowInConfirmModal(false)
                    approverPRAction({ prId: prId, SN: sn, comment: actionComment, history: history, action: 'cancel' })
                  }
                }
              }
            }}
          />
        </Modal.Actions>
      </Modal>
    </ProcurementBody>
  )
}

const mapStateToProps = (state) => {
  const valueForm = getFormValues('formEditPR')(state)

  return {
    valueForm,
    attachmentTypes: state.pr.attachmentTypes,
  }
}
const mapDispatchToProps = {
  approverPRAction,
  deletePr,
  updatePr,
  showModal,
  appLoading
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showInConfirmModal', 'setShowInConfirmModal', false),
  withState('actionComment', 'setActionComment', ''),
  withState('isResubmit', 'setIsResubmit', false),
  withState('errorRequireComment', 'setErrorRequireComment', false),
  reduxForm({
    form: 'formEditPR',
    enableReinitialize: true,
  }),
  connect((state, props) => ({

  })),
  lifecycle({
    componentDidMount() {

    },
    componentWillReceiveProps(nextProp) {

    }
  })
)

export default enhance(EditPRAction)
